import React, { useEffect, useState, useRef } from 'react';
import { get } from '@aws-amplify/api';
import { useLocation } from 'react-router-dom';
import './App.css';
import AppLayout from './components/AppLayout';

const CompareLongTerm = ({ signOut }) => {
  console.log("Executing CompareLongTerm");
  const myAPI = "mktappapi";
  const location = useLocation();
  let errorState = useRef(false);
  const [displayMessage, setDisplayMessage] = useState("");
  const [securitiesData, setSecuritiesData] = useState([]); 
  let email = useRef();

  const tooltipDescriptions = {
    roe: "Return on Equity (ROE) - Measures profitability relative to shareholders' equity.",
    roa: "Return on Assets (ROA) - Indicates how efficiently a company uses its assets to generate profit.",
    roic: "Return on Invested Capital (ROIC) - Evaluates profitability of capital invested in the company.",
    pe: "Price-to-Earnings Ratio (P/E) - Lower is generally better for value investing.",
    evebitda: "Enterprise Value to EBITDA - Lower values indicate better valuation.",
    debtequity: "Debt-to-Equity Ratio - Lower is better, indicating lower financial risk.",
    marketCapGrowth: "Market Capitalization Growth - Higher indicates strong company growth.",
    earningsyield: "Earnings Yield - Higher values indicate stronger profitability.",
    fcfyield: "Free Cash Flow Yield - Measures free cash flow compared to price.",
    totalreturn: "Total Return - Includes capital gains and dividends.",
    score: "Overall investment score based on multiple financial metrics."
  };

  const queryParams = new URLSearchParams(location.search);
  const securitiesString = queryParams.get("securities") || "";
  console.log("Securities String received:", securitiesString);

  const securitiesArray = securitiesString
    ? securitiesString.split(",").map(security => security.trim()).filter(s => s !== "")
    : [];

  useEffect(() => {
    console.log("Executing useEffect");
    setDisplayMessage("Fetching market data...");
    
    compareLongTerm(securitiesArray)
      .then((securitiesDataResp) => {
        console.log("useEffect : securitiesData = ", securitiesDataResp);
        setSecuritiesData(securitiesDataResp || []);
        setDisplayMessage("");
      })
      .catch((error) => {
        console.log("useEffect : error = ", error);
        setDisplayMessage("Error fetching data.");
      });
  }, []); 

  async function compareLongTerm(securities) {
    console.log("compareLongTerm : securities = ", securities);
    try {
      const param = { "stocks": securities };
      let path = '/compareLongTerm';
      let passApiStr = path + "/" + JSON.stringify(param);

      console.log("compareLongTerm : passApistr = ", passApiStr);
      passApiStr = encodeData(passApiStr);
      console.log("compareLongTerm : passApistr encoded = ", passApiStr);

      const response = await get({
        apiName: myAPI,
        path: passApiStr,
      }).response;

      let resp = await response.body.json();
      console.log("compareLongTerm : API Response = ", resp);
      return resp;
    } catch (error) {
      console.log("compareLongTerm : error = ", error);
      errorState.current = true;
      setDisplayMessage(error.message);
      return [];
    }
  }

  function encodeData(txt) {
    return txt.replace(/\{/g, "%7B")
      .replace(/\}/g, "%7D")
      .replace(/\[/g, "%5B")
      .replace(/\]/g, "%5D")
      .replace(/\:/g, "%3A")
      .replace(/ /g, "%20")
      .replace(/\,/g, "%2C")
      .replace(/\"/g, "%22");
  }

  if (!securitiesData || securitiesData.length === 0) {
    return (
      <AppLayout signOut={signOut}>
        <div style={{ padding: '24px' }}>
          <div style={{
            padding: '12px',
            marginBottom: '16px',
            background: 'rgba(59, 130, 246, 0.1)',
            borderRadius: '8px',
            color: '#3b82f6',
            fontWeight: '500'
          }}>
            {displayMessage}
          </div>
        </div>
      </AppLayout>
    );
  }

  const keys = Object.keys(securitiesData[0]).filter(key => key !== "symbol" && key !== "weights");

  return (
    <AppLayout signOut={signOut}>
      <div style={{ padding: '24px' }}>
        {/* Page Title */}
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)', marginBottom: '8px' }}>
            Ranked Securities for Long-Term Investment
          </h1>
          <p style={{ fontSize: '14px', color: 'rgba(107, 114, 128, 1)' }}>Best to Worst</p>
        </div>

        {/* Loading Message */}
        {displayMessage && (
          <div style={{
            padding: '12px',
            marginBottom: '16px',
            background: 'rgba(59, 130, 246, 0.1)',
            borderRadius: '8px',
            color: '#3b82f6',
            fontWeight: '500'
          }}>
            {displayMessage}
          </div>
        )}

        {/* Data Table */}
        <div style={{
          background: 'rgba(255, 255, 255, 0.95)',
          border: '1px solid rgba(229, 231, 235, 1)',
          borderRadius: '12px',
          padding: '24px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
          overflowX: 'auto'
        }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '14px'
          }}>
        <thead>
          <tr>
            <th style={{
              padding: '12px 16px',
              textAlign: 'left',
              fontWeight: '600',
              fontSize: '13px',
              color: 'rgba(0, 0, 0, 0.7)',
              borderBottom: '2px solid rgba(229, 231, 235, 1)',
              background: 'rgba(249, 250, 251, 1)',
              position: 'sticky',
              left: 0,
              zIndex: 1
            }}>
              Symbol
            </th>
            <th style={{
              padding: '12px 16px',
              textAlign: 'right',
              fontWeight: '600',
              fontSize: '13px',
              color: 'rgba(0, 0, 0, 0.7)',
              borderBottom: '2px solid rgba(229, 231, 235, 1)',
              background: 'rgba(249, 250, 251, 1)',
              cursor: 'help'
            }} title="Return on Equity (ROE) - Measures profitability relative to shareholders' equity.">
              ROE
            </th>
            <th style={{
              padding: '12px 16px',
              textAlign: 'right',
              fontWeight: '600',
              fontSize: '13px',
              color: 'rgba(0, 0, 0, 0.7)',
              borderBottom: '2px solid rgba(229, 231, 235, 1)',
              background: 'rgba(249, 250, 251, 1)',
              cursor: 'help'
            }} title="Return on Assets (ROA) - Indicates how efficiently a company uses its assets to generate profit.">
              ROA
            </th>
            <th style={{
              padding: '12px 16px',
              textAlign: 'right',
              fontWeight: '600',
              fontSize: '13px',
              color: 'rgba(0, 0, 0, 0.7)',
              borderBottom: '2px solid rgba(229, 231, 235, 1)',
              background: 'rgba(249, 250, 251, 1)',
              cursor: 'help'
            }} title="Return on Invested Capital (ROIC) - Evaluates profitability of capital invested in the company.">
              ROIC
            </th>
            <th style={{
              padding: '12px 16px',
              textAlign: 'right',
              fontWeight: '600',
              fontSize: '13px',
              color: 'rgba(0, 0, 0, 0.7)',
              borderBottom: '2px solid rgba(229, 231, 235, 1)',
              background: 'rgba(249, 250, 251, 1)',
              cursor: 'help'
            }} title="Price-to-Earnings Ratio (P/E) - Lower is generally better for value investing.">
              P/E
            </th>
            <th style={{
              padding: '12px 16px',
              textAlign: 'right',
              fontWeight: '600',
              fontSize: '13px',
              color: 'rgba(0, 0, 0, 0.7)',
              borderBottom: '2px solid rgba(229, 231, 235, 1)',
              background: 'rgba(249, 250, 251, 1)',
              cursor: 'help'
            }} title="Enterprise Value to EBITDA - Lower values indicate better valuation. EBITDA = Operating Income + Depreciation + Amortization">
              EV/EBITDA
            </th>
            <th style={{
              padding: '12px 16px',
              textAlign: 'right',
              fontWeight: '600',
              fontSize: '13px',
              color: 'rgba(0, 0, 0, 0.7)',
              borderBottom: '2px solid rgba(229, 231, 235, 1)',
              background: 'rgba(249, 250, 251, 1)',
              cursor: 'help'
            }} title="Debt-to-Equity Ratio - Lower is better, indicating lower financial risk.">
              D/E
            </th>
            <th style={{
              padding: '12px 16px',
              textAlign: 'right',
              fontWeight: '600',
              fontSize: '13px',
              color: 'rgba(0, 0, 0, 0.7)',
              borderBottom: '2px solid rgba(229, 231, 235, 1)',
              background: 'rgba(249, 250, 251, 1)',
              cursor: 'help'
            }} title="Market Capitalization Growth - Higher indicates strong company growth.">
              Market Cap Growth
            </th>
            <th style={{
              padding: '12px 16px',
              textAlign: 'right',
              fontWeight: '600',
              fontSize: '13px',
              color: 'rgba(0, 0, 0, 0.7)',
              borderBottom: '2px solid rgba(229, 231, 235, 1)',
              background: 'rgba(249, 250, 251, 1)',
              cursor: 'help'
            }} title="Earnings Yield - Higher values indicate stronger profitability.">
              Earnings Yield
            </th>
            <th style={{
              padding: '12px 16px',
              textAlign: 'right',
              fontWeight: '600',
              fontSize: '13px',
              color: 'rgba(0, 0, 0, 0.7)',
              borderBottom: '2px solid rgba(229, 231, 235, 1)',
              background: 'rgba(249, 250, 251, 1)',
              cursor: 'help'
            }} title="Free Cash Flow Yield - Measures free cash flow compared to price.">
              FCF Yield
            </th>
            <th style={{
              padding: '12px 16px',
              textAlign: 'right',
              fontWeight: '600',
              fontSize: '13px',
              color: 'rgba(0, 0, 0, 0.7)',
              borderBottom: '2px solid rgba(229, 231, 235, 1)',
              background: 'rgba(249, 250, 251, 1)',
              cursor: 'help'
            }} title="Total Return - Includes capital gains and dividends.">
              Total Return
            </th>
            <th style={{
              padding: '12px 16px',
              textAlign: 'right',
              fontWeight: '600',
              fontSize: '13px',
              color: 'rgba(0, 0, 0, 0.7)',
              borderBottom: '2px solid rgba(229, 231, 235, 1)',
              background: 'rgba(249, 250, 251, 1)',
              cursor: 'help'
            }} title="Overall investment score based on multiple financial metrics.">
              Score
            </th>
          </tr>
        </thead>
        <tbody>
          {securitiesData.map((security, index) => (
            <tr key={index} style={{
              borderBottom: index < securitiesData.length - 1 ? '1px solid rgba(229, 231, 235, 1)' : 'none',
              transition: 'background 0.2s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(249, 250, 251, 0.5)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}>
              <td style={{
                padding: '12px 16px',
                fontWeight: '600',
                color: 'rgba(0, 0, 0, 0.9)',
                position: 'sticky',
                left: 0,
                background: 'inherit',
                zIndex: 1
              }}>
                {security.symbol}
              </td>
              {keys.map((key) => (
                <td key={key} style={{
                  padding: '12px 16px',
                  textAlign: 'right',
                  color: 'rgba(0, 0, 0, 0.7)',
                  fontFamily: 'monospace'
                }}>
                  {typeof security[key] === "number" ? security[key].toFixed(4) : security[key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
        </div>
      </div>
    </AppLayout>
  );
};

export default CompareLongTerm;